export const ALLOWED_LIST_TAGS = new Set(['ol', 'ul'])
